import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const UserGroupFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M10.75 8.558c1.433 0 2.6-1.166 2.6-2.591 0-1.425-1.167-2.6-2.6-2.6a2.603 2.603 0 0 0-2.6 2.6 2.596 2.596 0 0 0 2.6 2.591ZM11.55 8.992h-1.6a4.833 4.833 0 0 0-4.825 4.825v1.716c0 .7.567 1.267 1.267 1.267h8.716c.7 0 1.267-.567 1.267-1.267v-1.716a4.833 4.833 0 0 0-4.825-4.825Z" />
      <Path d="M5.258 10.325a1.992 1.992 0 1 0 0-3.983 1.992 1.992 0 0 0 0 3.983ZM16.358 10.325a1.992 1.992 0 1 0 0-3.983 1.992 1.992 0 0 0 0 3.983ZM2.4 14.367v1.6c0 .458.392.833.867.833h1.075v-2.858a5.4 5.4 0 0 1 .891-2.992c-1.641.492-2.833 1.825-2.833 3.417ZM16.358 10.95c.559.858.892 1.883.892 2.992V16.8h1.075c.483 0 .867-.375.867-.833v-1.6c0-1.592-1.192-2.925-2.834-3.417Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.75)" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UserGroupFilled
